// This file was generated using `pay js:run gql-v1 --type=mutation --name=UpdateEmbeddedSurfacesLastAccessed --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

import type {
  V1MutationOptionsWithoutVariables,
  V1MutationOptions,
  V1MutationReturn,
  V1PermissionToken,
} from '@stripe-internal/data-v1/types';
import {useV1Mutation} from '@stripe-internal/data-v1';
import {gql} from '@sail/data';

import type {GraphQlDocument, ApolloError} from '@sail/data';

import type {
  Exact,
  InputMaybe,
  OpenapiPostV1EmbeddedSurfacesInput,
  V1ContextInput,
} from '@stripe-internal/data-v1/schema/types';

const doc = gql`
  mutation UpdateEmbeddedSurfacesLastAccessedMutation(
    $input: OpenapiPostV1EmbeddedSurfacesInput
    $v1Context: V1ContextInput!
  ) {
    v1EmbeddedSurfaces(input: $input, v1Context: $v1Context) {
      id
      merchant
      livemode
    }
  }
`;

export const updateEmbeddedSurfacesLastAccessedMutation: UpdateEmbeddedSurfacesLastAccessedMutationDocument =
  doc;

// Fill these options as needed. Options are documented at
// http://go/sail/apis/data/graphql-usage/the-basics-runtime#operation-options
const updateEmbeddedSurfacesLastAccessedMutationOptions: V1MutationOptionsWithoutVariables<UpdateEmbeddedSurfacesLastAccessedMutationDocument> =
  {
    // expectedErrors: [],
    // mutedErrors: [],
    // fetchPolicy: 'cache-first',
    // ...

    // TODO: This is a legacy behavior that was present in the original Apollo
    // wrappers and is not standard. If you are not using this error for anything
    // feel free to remove it (More info: go/throw-errors-on-mutations)
    onError(error: ApolloError) {
      throw error;
    },
  };

export default function useUpdateEmbeddedSurfacesLastAccessedMutation(
  options: V1MutationOptions<UpdateEmbeddedSurfacesLastAccessedMutationDocument> = {},
): V1MutationReturn<UpdateEmbeddedSurfacesLastAccessedMutationDocument> {
  return useV1Mutation(
    updateEmbeddedSurfacesLastAccessedMutation,
    Object.assign(
      {},
      updateEmbeddedSurfacesLastAccessedMutationOptions,
      options,
    ),
  );
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type UpdateEmbeddedSurfacesLastAccessedMutationVariables = Exact<{
  input?: InputMaybe<OpenapiPostV1EmbeddedSurfacesInput>;
  v1Context: V1ContextInput;
}>;

export type UpdateEmbeddedSurfacesLastAccessedMutationData = {
  readonly __typename: 'Mutation';
  readonly v1EmbeddedSurfaces: {
    readonly __typename: 'OpenapiConnectEmbeddedMethodEmbeddedSurfaceLastAccessedUpdateMethodEmbeddedSurfaceUpdate';
    readonly id: string;
    readonly merchant: string;
    readonly livemode: boolean;
  } | null;
};

const updateEmbeddedSurfacesLastAccessedMutationPermissions = {} as const;

doc.permissions = updateEmbeddedSurfacesLastAccessedMutationPermissions;

export type UpdateEmbeddedSurfacesLastAccessedMutationPermissions =
  V1PermissionToken<
    typeof updateEmbeddedSurfacesLastAccessedMutationPermissions
  >;

export type UpdateEmbeddedSurfacesLastAccessedMutationDocument =
  GraphQlDocument<
    UpdateEmbeddedSurfacesLastAccessedMutationData,
    UpdateEmbeddedSurfacesLastAccessedMutationVariables,
    UpdateEmbeddedSurfacesLastAccessedMutationPermissions
  >;
